<ng-container *ngIf="isVisible">
  <button
    type="button"
    class="assistant-launcher"
    [class.assistant-launcher--hidden]="isOpen"
    (click)="open()"
    aria-controls="assistant-panel"
    [attr.aria-expanded]="isOpen">
    <span class="assistant-mark">R</span>
    Pitaj Ratka
  </button>

  <aside
    id="assistant-panel"
    class="assistant-panel"
    [class.assistant-panel--open]="isOpen"
    [class.assistant-panel--resizing]="isResizing"
    [style.width.px]="width"
    aria-label="Ratko, asistent"
    [attr.aria-hidden]="!isOpen">
    <div
      class="assistant-panel__handle"
      (mousedown)="startResize($event)"
      (dblclick)="resetWidth()"
      title="Prevuci za širinu, dvoklik vraća podrazumevanu"
      role="separator"
      aria-orientation="vertical"
      aria-label="Promena širine panela"></div>
    <div class="assistant-panel__head">
      <span class="assistant-mark assistant-mark--lg">R</span>
      <div class="assistant-panel__title">
        <b>Ratko</b>
        <small>Čita podatke iz Banima, ništa ne menja</small>
      </div>
      <button
        type="button"
        class="assistant-btn"
        [class.assistant-btn--active]="isHistoryOpen"
        (click)="toggleHistory()"
        [attr.aria-expanded]="isHistoryOpen"
        title="Prethodni razgovori">
        Razgovori
      </button>
      <button
        type="button"
        class="assistant-btn"
        (click)="newConversation()"
        [disabled]="!isHistoryOpen && !messages.length && !isStreaming"
        title="Novi razgovor">
        Novi razgovor
      </button>
      <button type="button" class="assistant-btn" (click)="close()" aria-label="Zatvori">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div class="assistant-history" *ngIf="isHistoryOpen">
      <div class="assistant-history__note" *ngIf="historyError">
        <i class="fa fa-exclamation-circle"></i> {{ historyError }}
      </div>
      <div class="assistant-history__note" *ngIf="isHistoryLoading && !conversations.length">Učitavam…</div>
      <div class="assistant-history__note" *ngIf="!isHistoryLoading && !conversations.length && !historyError">
        Nema ranijih razgovora.
      </div>

      <div
        class="assistant-history__row"
        *ngFor="let conversation of conversations; trackBy: trackByConversation"
        [class.assistant-history__row--current]="conversation.conversationId === openConversationId">
        <button
          type="button"
          class="assistant-history__open"
          [disabled]="isStreaming"
          [title]="isStreaming ? 'Sačekaj da Ratko završi odgovor' : conversationTitle(conversation)"
          (click)="openConversation(conversation)">
          <span class="assistant-history__title">{{ conversationTitle(conversation) }}</span>
          <small>{{ conversation.updatedAt | date: 'dd/MM/yyyy HH:mm' }} · {{ conversation.messageCount }}</small>
        </button>
        <i
          class="fa fa-trash pointer assistant-history__delete"
          role="button"
          tabindex="0"
          [attr.aria-label]="'Obriši razgovor ' + conversationTitle(conversation)"
          (click)="askDelete(conversation)"
          (keydown.enter)="askDelete(conversation)"></i>
      </div>
    </div>

    <div class="assistant-messages" #messagesEl *ngIf="!isHistoryOpen">
      <div class="assistant-empty" *ngIf="!messages.length">
        <span class="assistant-mark assistant-mark--xl">R</span>
        <h3>Šta te zanima?</h3>
        <p>Odgovaram iz živih podataka, samo ono što i inače možeš da vidiš u aplikaciji.</p>
        <div class="assistant-suggest">
          <button type="button" *ngFor="let suggestion of suggestions" (click)="useSuggestion(suggestion)">{{ suggestion }}</button>
        </div>
      </div>

      <ng-container *ngFor="let message of messages; trackBy: trackByIndex">
        <div class="assistant-msg assistant-msg--user" *ngIf="message.role === 'user'">{{ message.text }}</div>

        <ng-container *ngIf="message.role === 'assistant'">
          <div class="assistant-step" *ngFor="let step of message.steps; let i = index" [class.assistant-step--active]="isStepActive(message, i)">
            <span class="assistant-step__dot"></span>
            <span>{{ step.message }}</span>
          </div>

          <div class="assistant-msg assistant-msg--ratko" *ngIf="message.text || message.error || (message.streaming && !message.steps.length)">
            <span class="assistant-mark">R</span>
            <div class="assistant-msg__body">
              <markdown *ngIf="message.text" [data]="message.text"></markdown>
              <span class="assistant-caret" *ngIf="message.streaming && !message.text"></span>
              <div class="assistant-error" *ngIf="message.error">
                <i class="fa fa-exclamation-circle"></i> {{ message.error }}
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <form class="assistant-composer" (ngSubmit)="onSubmit()" *ngIf="!isHistoryOpen">
      <div class="assistant-composer__row">
        <textarea
          #inputEl
          name="draft"
          rows="1"
          [(ngModel)]="draft"
          (input)="resizeInput()"
          (keydown)="onKeydown($event)"
          placeholder="Pitaj o nalozima, planu, materijalima…"
          aria-label="Poruka za Ratka"></textarea>
        <button type="submit" class="assistant-send" [class.assistant-send--stop]="isStreaming" [disabled]="!isStreaming && !draft.trim()">
          {{ isStreaming ? 'Zaustavi' : 'Pošalji' }}
        </button>
      </div>
      <div class="assistant-hint">
        <span>Enter šalje · Shift+Enter novi red</span>
        <span>Odgovori navode izvor podataka</span>
      </div>
    </form>
  </aside>

  <!--
    Van <aside>: panel ima transform, koji pravi novi stacking context, pa bi
    position:fixed modal bio zarobljen unutar panela i prikazao se iza njega -
    videla bi se samo zatamnjena pozadina.
  -->
  <app-question-modal
    *ngIf="conversationToDelete"
    [text]="'Da li ste sigurni da želite da obrišete razgovor - ' + conversationTitle(conversationToDelete) + '?'"
    (responseChanged)="onDeleteAnswer($event)">
  </app-question-modal>
</ng-container>
